import { FC } from 'react';
import GirlStubWebp from '@edikk-edikk/country-common/images/girl-stub.webp';
import galleryCss from '../../assets/gallery/gallery.module.scss';
import galleryItemCss from '../../assets/gallery/gallery-item.module.scss';

const GalleryStub: FC = () => (
  <div className={galleryCss.gallery}>
    <div className={galleryItemCss.galleryItem}>
      <img src={GirlStubWebp} className={galleryItemCss.galleryItem__img} />
    </div>
  </div>
);

export { GalleryStub };
